module.exports = __webpack_public_path__ + "img/iconTrash.7218815a.svg";